import styled from "styled-components";

import { blueMui, greenMui } from "@ryde/theme";

export const RideAreaGroupSupplierIndicatorsIconRow = styled.label.attrs({
  className: "ride-indicators__ag-row",
})`
  display: inline-flex;
  align-items: center;
  gap: 4px;

  .ride-indicators__ag-pin {
    font-size: 16px;
    vertical-align: text-bottom;
    color: ${blueMui._700};
  }

  .ride-indicators__ag-priority {
    font-size: 16px;
    vertical-align: text-bottom;
    color: ${greenMui._700};
  }
`;
